import React from 'react';
import './LessonInfo.css';

function LessonInfo() {
    return (
        <div className="lesson__info">
            <p>Цена курса: 4 650 ₽/мес</p>
            <p>Старт: 1 апреля</p>
            <p>Формат: Онлайн</p>
            <p>Длительность: 12 месяцев</p>
            <p>Уровень: с нуля</p>
        </div>
    )
}

export default LessonInfo
